<script>
import { mapState } from 'vuex'
/* eslint-disable-next-line */
import ScaleQuiz from '@/components/ScaleQuiz.vue'
import Scale from '@/components/Scale.vue'
import Instruments from '@/components/Instruments.vue'

export default {
  components: {
    ScaleQuiz, Scale, Instruments
  },
  computed: {
    ...mapState(['notes', 'soundHelper'])
  },
  data () {
    return {
      myNotes: this.$store.state.notes.filter(note => note.solfege !== 'fa' && note.solfege !== 'ti')
    }
  },
  methods: {
    playNote (freq, solfege) {
      this.soundHelper.playSound(freq, solfege, 500)
    }
  }

}
</script>

<template>
  <div>
    <div style="display:flex;justify-content:center;align-items:center;margin-bottom:10px;">Pentatonic Scale <Instruments /></div>
    <Scale :notes="myNotes" :noteClicked="playNote" />
    <ScaleQuiz :notes="myNotes" :playNote="playNote" />
  </div>
</template>
